import React from 'react'
import VisionBox from './components/VisionBox'

const VisionMission = () => {
  return (
    <div className='px-16 max-[450px]:px-8 max-md:py-8'>
      <div className='py-16 flex max-md:flex-wrap justify-center items-stretch gap-6 border-b-4'>
        <VisionBox borderColor="bg-[#213874]" header="Our Vision" content="To amplify the giving culture in Africa and bring visibility to those who are most in need." />
        <VisionBox left borderColor="bg-[#F57200]" header="Our Mission" content="To build a bridge that connects those who have to those in need." />
      </div>
    </div>
  )
}

export default VisionMission